// @flow
import * as React from 'react'
import moment from 'moment'
import { FormattedMessage } from 'mz-intl'
import messages from '../messages.intl'

// Types
import type { FlightInfo } from '../BasicFlightField'

type Props = {
  flightInfo: FlightInfo,
}

/**
 * Error message to show empty flight search results
 * @param {FlightInfo} flightInfo
 */
const NoFlightsFoundMessage = ({ flightInfo }: Props) => {
  const searchDatetime = flightInfo.flightDatetime || flightInfo.pickupDatetime
  const directionMessage =
    flightInfo.flightDirection === 'arr'
      ? messages.LANDING_AT
      : messages.DEPARTING_FROM

  return (
    <FormattedMessage
      message={messages.NO_FLIGHT_FOUND}
      values={{
        time: moment.parseZone(searchDatetime).format('hh:mm A'),
        direction: (
          <FormattedMessage
            message={directionMessage}
            values={{ airport: flightInfo.airportCode }}
          />
        ),
      }}
    />
  )
}

export default NoFlightsFoundMessage
